import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { updateBatchClaimsPaymentStatus } from './actions/index';
import { CancelButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from "../../../../components/reduxFields";
// import validate from './validate';



class UpdateBatchClaimPaymentStatusModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            selectedLedgerClaimIds: this.props.selectedLedgerClaimIds.length > 0 ? this.props.selectedLedgerClaimIds : []
        };
    }

    handleClose = () => {
        this.props.closeDialog();
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleNewRequest(input, selectedValue) {
        input.onChange(selectedValue.value);
        this.props.updateBatchClaimsPaymentStatus(this.state.selectedLedgerClaimIds, selectedValue.value, this.props.searchObj);
        this.setState({ open: false });
        this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        ];
        return (
            <Dialog
                className="custom_modal"
                title="Update Batch Claim Payment Status"
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form">
                            <div className="row">
                                <div className="col-sm-12 require" style={{ marginTop: '50px' }}>
                                    <Field
                                        name={`claimPaymentStatusId`}
                                        hintText="Status"
                                        handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                                        options={this.props.masterClaimPaymentStatus}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Dialog>
        );
    }
}

UpdateBatchClaimPaymentStatusModal = reduxForm({
    form: 'UpdateBatchClaimPaymentStatusModalForm',
    // validate,
    enableReinitialize: true,
})(UpdateBatchClaimPaymentStatusModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: false 
    }
}

export default connect(mapStateToProps, {updateBatchClaimsPaymentStatus})(UpdateBatchClaimPaymentStatusModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/UpdateBatchClaimPaymentStatusModal.js